import apiClient from './client';
import type { Wallet } from '../types';

export async function listWallets(): Promise<Wallet[]> {
	const res = await apiClient.get<{ wallets: Wallet[] }>('/wallets');
	return res.data.wallets;
}

export async function createWallet(input: { address: string; chain?: string; label?: string }): Promise<Wallet> {
	const res = await apiClient.post<{ wallet: Wallet }>('/wallets', input);
	return res.data.wallet;
}

export async function deleteWallet(walletId: string): Promise<void> {
	await apiClient.delete(`/wallets/${walletId}`);
}

export interface WalletAsset {
	symbol: string;
	amount: number;
	valueUsd: number;
	priceUsd: number;
}

export interface WalletMetrics {
	walletId: string;
	address: string;
	label: string;
	totalValueUsd: number;
	assetCount: number;
	assets: WalletAsset[];
	topAsset: {
		symbol: string;
		weightPct: number;
		valueUsd: number;
	};
	diversificationScore: number;
	riskLevel: 'low' | 'medium' | 'high' | 'critical';
	lastUpdated: string;
}

export interface PortfolioWalletBreakdown {
	userId: string;
	totalPortfolioValue: number;
	walletCount: number;
	wallets: WalletMetrics[];
	walletConcentration: Array<{
		walletId: string;
		label: string;
		valueUsd: number;
		weightPct: number;
	}>;
	largestWallet: WalletMetrics | null;
	riskDistribution: {
		low: number;
		medium: number;
		high: number;
		critical: number;
	};
}

export async function getPortfolioWalletBreakdown(userId: string): Promise<PortfolioWalletBreakdown> {
	const url = `/analytics/portfolio/wallets/${userId}`;
	const res = await apiClient.get<PortfolioWalletBreakdown>(url);
	return res.data;
}

export async function getWalletMetrics(userId: string, walletId: string): Promise<WalletMetrics> {
	const url = `/analytics/wallet/metrics/${userId}/${walletId}`;
	const res = await apiClient.get<WalletMetrics>(url);
	return res.data;
}